'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.swiper-slider {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n.swiper-slider .swiper-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.lp__carousel .carousel__inner-slide {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n  padding: 0;\n  position: static !important;\n}\n.lp__carousel .carousel__dot-group {\n  text-align: center;\n  padding: calc(0.5 * 1rem) 0;\n}\n.lp__carousel .carousel__dot {\n  content: \"\";\n  height: calc(0.75 * 1rem);\n  width: calc(0.75 * 1rem);\n  display: inline-block;\n  background: rgba(51, 51, 51, 0.43);\n  border-radius: calc(0.5 * 1rem);\n  cursor: pointer;\n  margin-right: calc(0.25 * 1rem);\n  border: none;\n  padding: 0;\n}\n.lp__carousel .carousel__dot:focus {\n  outline: none;\n}\n.lp__carousel .carousel__single-dot.selected {\n  width: calc(2 * 1rem);\n  background: #1D66DD;\n}\n.lp__carousel .carousel__single-dot > div {\n  height: 100%;\n  width: 100%;\n}\n.lp__carousel .button__back, .lp__carousel .button__next {\n  background: #ffffff;\n  border: 1px solid #dfdfdf;\n  border-radius: 4;\n}\n.lp__carousel .button_custom {\n  border: none !important;\n  background: transparent !important;\n}");
//# sourceMappingURL=Swiper.scss.js.map
